import React from "react"
import { Plural, Trans } from "@lingui/macro"
import clsx from "clsx"
import { Button, Icon, SanityImage } from "@silversea-ssc/ui-components-react"
import { buildCruiseName } from "../../../app-core/_common/format/cruise"
import { websiteUrl } from "../../../app-core/_common/localizeWebsiteUrl"
import CruiseDepartureArrivalDates from "../../CruiseDepartureArrivalDates"
import { FetchPageContent } from "../../../app-core/_common/sanity/fetch-page-content"
import { WebQuoteExitIntent } from "../../../app-core/features/_common/web-quote-exit-intent"
import styles from "./SidebarHeader.module.scss"

type Props = {
    sanityContent: FetchPageContent
    headerContentClassName?: string
    webQuoteExitIntent: WebQuoteExitIntent
}

const SidebarHeader: React.FC<Props> = ({ sanityContent, headerContentClassName, webQuoteExitIntent }) => {
    const { cruise, cruiseData } = sanityContent
    const cruiseName = buildCruiseName(cruiseData.departurePort.name, cruiseData.arrivalPort.name)
    const backToItineraryUrl = websiteUrl(cruise.path)
    const cruiseCode = cruise.cruiseCode
    const departureDate = cruiseData.departureDate
    const arrivalDate = cruiseData.arrivalDate
    const duration = cruiseData.days
    const shipName = cruiseData.ship.name
    const image = sanityContent.heroImage

    const backToItinerary = () => {
        if (webQuoteExitIntent.canTrigger) {
            webQuoteExitIntent.openExitIntentModal()
        } else {
            window.location.href = backToItineraryUrl
        }
    }

    return (
        <header className={styles.header}>
            <SanityImage image={image} width={400} height={140} className={styles.backgroundImage} />
            <div className={clsx(styles.content, headerContentClassName)}>
                <div className={styles.title}>{cruiseName}</div>
                <div className={styles.dates} suppressHydrationWarning>
                    <CruiseDepartureArrivalDates departureDate={departureDate} arrivalDate={arrivalDate} /> •{" "}
                    <Plural value={duration} one="# Day" other="# Days" />
                </div>

                <div className={styles.context}>
                    <div className={styles.ship}>
                        <Icon name="ship" padding={"inline-right"} /> {shipName} |{" "}
                        <Trans>Voyage number #{cruiseCode}</Trans>
                    </div>
                </div>

                <div className={styles.backToItinerary}>
                    <Button
                        renderAs="button"
                        size="small"
                        variant="inline-text"
                        onClick={backToItinerary}
                        dataContentPiece="back-to-itinerary-link"
                    >
                        <Trans>Back to itinerary</Trans>
                    </Button>
                </div>
            </div>
        </header>
    )
}

export default SidebarHeader
